/**
 * The Charter Board's Votes panel (M5 plan C17, spec §15.2, §18 flow 7): each vote's measure, sponsor, hearing
 * day, evidence, the ballots (faction, weight, Yes/No in words) and the result. Rendered from `votesModel`. The
 * corporation's ballot shows under its name and weight; a ban notes that it binds the corporation's space (§27.8).
 */
import type { ReactNode } from 'react'
import type { VoteRow } from './boardModel'

export interface VotesPanelProps {
  votes: readonly VoteRow[]
}

export function VotesPanel(p: VotesPanelProps): ReactNode {
  return (
    <section className="cb-votes" data-testid="charter-votes" aria-label="Charter votes">
      <h3 className="sui-section__title">Charter votes</h3>
      {p.votes.length === 0 ? <p className="sui-empty">No Charter hearings scheduled.</p> : null}
      <ol className="cb-votes__list">
        {p.votes.map((v) => (
          <li key={v.id} className="cb-vote" data-result={v.result} data-testid="charter-vote">
            <div className="cb-vote__head">
              <strong>{v.measure}</strong> · sponsor {v.sponsor} · {v.when} · {v.evidence} · <span className="cb-vote__result">{v.resultLabel}</span>
            </div>
            {v.scope !== null ? (
              <p className="cb-vote__scope" data-testid="charter-vote-scope">
                {v.scope}
              </p>
            ) : null}
            {v.ballots.length > 0 ? (
              <>
                <ul className="cb-ballots">
                  {v.ballots.map((b) => (
                    <li key={b.faction} className="cb-ballot" data-yes={b.yes ? '' : undefined}>
                      <span className="cb-chip" style={{ borderColor: b.look.color }}>
                        {b.look.mark}
                      </span>{' '}
                      {b.label}
                    </li>
                  ))}
                </ul>
                <div className="cb-vote__tally">
                  Yes {fmt(v.yes)} · No {fmt(v.no)}
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </section>
  )
}

function fmt(w: number): string {
  return Number.isInteger(w) ? String(w) : w.toFixed(1)
}
